import React from 'react'
import { SimpleForm, TextInput, required, useEditController, useTranslate } from 'react-admin'
import { Grid } from '@mui/material'
import { EditBase } from '../../components/base'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { ImageInput } from '../../components/inputs'
import { PORTAL_MENUS_FIELDS } from '../../providers/localization/constant'

const PortalMenuEdit = (props): JSX.Element => {
  const translate = useTranslate()
  // return <span>d</span>

  const { record } = useEditController(props)
  return (
    <EditBase
      // title={`${RESOURCE_PREFIX}.title`}
      encType='multipart/form-data'
      redirect='list'
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
    >
      <SimpleForm
        record={{ ...record, encType: 'multipart/form-data' }}
        toolbar={
          <FormBottomToolbarWithPermission
            encType='multipart/form-data'
            hasConfirm={true}
            showDeleteButton={false}
          />
        }
      >
        <TextInput
          label={translate(`${PORTAL_MENUS_FIELDS}.order`)}
          disabled
          source='order'
          fullWidth
        />
        <TextInput
          label={translate(`${PORTAL_MENUS_FIELDS}.target_url`)}
          source='target_url'
          fullWidth
          validate={required()}
        />
        <Grid container spacing={2} alignItems='flex-start' justifyContent='center'>
          <Grid item xs={12} sm={6}>
            <ImageInput
              label={translate(`${PORTAL_MENUS_FIELDS}.image_desktop`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_desktop'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ImageInput
              label={translate(`${PORTAL_MENUS_FIELDS}.image_mobile`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_mobile'
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </EditBase>
  )
}

export default PortalMenuEdit
